import { Component, Input } from '@angular/core';
import { FormViewState } from 'src/app/common/models/form-view-state';

@Component({
  selector: 'form-history-eb',
  templateUrl: './form-history-eb.component.html',
  styleUrls: ['./form-history-eb.component.scss']
})
export class FormHistoryEbComponent {
  @Input() originalBody: any;
  @Input() update: any;
  @Input() status?: FormViewState;
}
